// extracted by mini-css-extract-plugin
export default {"submit":"CreateInitialAssessmentSummaryPage_submit__q4ytx"};